import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const vuetify = new Vuetify({
	theme: {
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: '#171617',
				secondary: '#FFF',
				accent: '#82B1FF',
				error: '#FF5252',
				info: '#2196F3',
				success: '#171617',
				successgreen: '#4CAF50',
				warning: '#FFC107',
				link: colors.blue.darken4,
			},
		},
	},
})

export default { vuetify }
